module.exports = __webpack_public_path__ + "static/itsm_capabilities_2-a2a9959429d14520500c2a96cefbc19c.png";